export default "__VITE_ASSET__CqqM02tm__"